module.exports = __webpack_public_path__ + "static/media/11.9a0db4bb.png";